import {InjectionToken} from '@angular/core';

export const Production = new InjectionToken<boolean>('Production');
export const HMR = new InjectionToken<boolean>('HMR');
